// WildWaters.js
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import "./AboutUs.css";
import image1 from "../../assets/image/about1.jpg";
import image2 from "../../assets/image/about2.jpg";
import image3 from "../../assets/image/about3.jpg";
import image4 from "../../assets/image/about4.jpg";
import image5 from "../../assets/image/Group (2).png";
import image6 from "../../assets/image/Vector.png";
import { Helmet } from "react-helmet";

export default function AboutUs() {
  const [title, setTitle] = useState("من نحن");
  const location = useLocation();

  useEffect(() => {
    const interval = setInterval(() => {
      setTitle((prev) => (prev === "من نحن" ? "شركه التنظيم" : "من نحن"));
    }, 2000); // كل ثانية

    return () => clearInterval(interval); // تنظيف الـ interval عند الخروج
  }, []);
  return (
    <>
      <Helmet>
        <title>شركة التنظيم للسفر والسياحة | أفضل شركة سياحة في السعودية</title>
        <meta
          name="description"
          content=" ! شركة التنظيم للسفر والسياحة، أفضل شركة سياحة في السعودية. نوفر رحلات مميزة، عروض سياحية متنوعة، وخدمات حجز الفنادق والتأشيرات. احجز الآن"
        />
        <link
          rel="canonical"
          href={`https://tnzeem-sa.com${location.pathname}`}
        />

        <meta
          name="keywords"
          content="شركة سياحة, رحلات سياحية, عروض سياحية, حجز فنادق, تأشيرات, السياحة في السعودية"
        />
        <link
          rel="alternate"
          hreflang="ar"
          href={`https://tnzeem-sa.com${location.pathname}`}
        />
        <link
          rel="alternate"
          hreflang="x-default"
          href={`https://tnzeem-sa.com${location.pathname}`}
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "TravelAgency",
            name: "التنظيم للسفر والسياحة",
            description:
              "شركة التنظيم للسفر والسياحة | أفضل شركة سفر وسياحة في السعودية",
            url: "https://tnzeem-sa.com/about",
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "الرئيسية",
                item: "https://tnzeem-sa.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "من نحن",
                item: "https://tnzeem-sa.com/about",
              },
            ],
          })}
        </script>
      </Helmet>

      <div className="wild-waters-section" dir="ltr">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="image-grid">
              <div className="image-item">
                <img src={image1} alt="1" />
              </div>
              <div className="image-item">
                <img src={image2} alt="2" />
              </div>
              <div className="image-item">
                <img src={image4} alt="3" />
              </div>
              <div className="image-item">
                <img src={image3} alt="4" />
              </div>
            </Col>
            <Col lg={6} className="text-content">
              <h1 className="titlle">{title}</h1>
              <p className="description">
                نحن شركة رائدة في مجال السياحة والسفر، نقدم خدمات  متعدده
                لعملائنا منذ سنوات عديدة <br />
                نسعى دائماً لتقديم أفضل الخدمات وأكثرها تميزاً لضمان تجربة سفر
                لا تُنسى لعملائنا
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="contact-banner container my-5">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-white gap-3 px-4 py-3">
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <FaPhoneAlt className="fs-4" />
            <a
              href="tel:920033239"
              className="text-white fw-bold text-decoration-none me-2"
            >
              920033239
            </a>
            <span className="text-white">|</span>
            <a
              href="tel:920033239"
              className="text-white fw-bold text-decoration-none ms-2"
            >
              920033239
            </a>
          </div>

          <div className="text-center flex-grow-1 fw-bold fs-5">
ابدا معنا بصنع  بسبتك اليوم          </div>

          <a
            href="/contact"
            className="btn btn-light btn-lg rounded-pill px-4 fw-bold contact-btn"
          >
            تواصل معنا الآن
          </a>
        </div>
      </div>
      <section className="feature-cards-section py-5" dir="rtl">
        <Container>
          <Row className="justify-content-center text-center">
            <Col xs={12} md={6} lg={5} className="mb-5">
              <div className="card-item">
                <div className="half-circle-image">
                  <img src={image6} alt="شراكة معنا" />
                </div>
                <h5 className="card-title">← شراكة معنا</h5>
                <p className="card-text">
                  نربط شركاءنا من مختلف الأحجام بعالم السفر، ونوفر لهم الوصول
                  إلى البيانات والأدوات والتقنيات الحديثة التي تعزز إمكانياتهم
                  وتنمّي أعمالهم.
                </p>
              </div>
            </Col>

            <Col xs={12} md={6} lg={5} className="mb-5">
              <div className="card-item">
                <div className="half-circle-image">
                  <img src={image5} alt="سافر معنا" />
                </div>
                <h5 className="card-title">← سافر معنا</h5>
                <p className="card-text">
                  في شركة التنظيم، نوفر تجارب سفر متعدده تناسب جميع العملاء،
                  ونضمن لهم أفضل قيمة مقابل رحلاتهم وخدمة مميزة لا تُنسى.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
